import type { VoidFunctionComponent } from 'react';

import { FormLabel, LabeledCheckbox } from '../../../generic';
import Flex from '../../../generic/Flex';
import NumberInputWithUnit from '../../../settings/shared/NumberInputWithUnit';

import styles from './GeneralSettings.module.less';

const DEFAULT_THRESHOLD = 10;

export type Props = {
  canEdit: boolean;
  isSaving: boolean;
  threshold?: number;
  onUpdate: (threshold?: number) => void;
};

const SnippetAutoRejectThreshold: VoidFunctionComponent<Props> = ({
  canEdit,
  isSaving,
  threshold,
  onUpdate,
}) => {
  const isEnabled = threshold !== undefined;
  const label = 'Snippet Auto-Reject Threshold';
  return (
    <FormLabel label={label}>
      <Flex gap="12px" align="center" justify="flex-start">
        <div className={styles.snippetAutoRejectThresholdCheckbox}>
          <LabeledCheckbox
            label="Enabled"
            isChecked={isEnabled}
            onChange={(_, checked) => {
              onUpdate(checked ? DEFAULT_THRESHOLD : undefined);
            }}
          />
        </div>
        {isEnabled && (
          <NumberInputWithUnit
            unit="percent"
            label="Snippet Auto-Reject Threshold"
            value={threshold}
            onChange={(newThreshold) => onUpdate(newThreshold)}
            isDisabled={!isEnabled || !canEdit || isSaving}
          />
        )}
      </Flex>
      <div className={`${styles.smallText} ${styles.smallTextInfo}`}>
        Any snippets files with a match percentage less than or equal to this value will be
        automatically rejected. They will still appear in the UI as a rejected snippet.
      </div>
    </FormLabel>
  );
};

export default SnippetAutoRejectThreshold;
